import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useState, useCallback } from 'react';
import { parseMultiEnumValue } from 'customer-data-property-utils/parseMultiEnumValue';
import TagsPopoverContent from './TagsPopoverContent';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { jsx as _jsx } from "react/jsx-runtime";
const TagsShowMore = ({
  tags,
  object,
  objectTypeDef
}) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const tagCount = parseMultiEnumValue(tags.value).length;
  const renderPopoverContents = useCallback(() => /*#__PURE__*/_jsx(TagsPopoverContent, {
    tags: tags,
    object: object,
    objectTypeDef: objectTypeDef,
    onClosePopover: () => setIsPopoverOpen(false)
  }), [object, objectTypeDef, tags]);
  const handleClick = useCallback(evt => {
    evt.preventDefault();
    evt.stopPropagation();
    setIsPopoverOpen(previousValue => !previousValue);
  }, []);

  // Need to eat the click, otherwise the preview panel shows up
  const handleOuterClick = useCallback(evt => {
    evt.stopPropagation();
  }, []);
  if (tagCount <= 1) {
    return null;
  }
  return /*#__PURE__*/_jsx("span", {
    onClick: handleOuterClick,
    children: /*#__PURE__*/_jsx(Popover, {
      "data-test-id": "cdbc-tag-popover",
      inlineSize: "300px",
      open: isPopoverOpen,
      showCloseButton: true,
      closeOnOutsideClick: true,
      onOpenChange: () => setIsPopoverOpen(false),
      Content: renderPopoverContents,
      children: /*#__PURE__*/_jsx(Button, {
        use: "link",
        onClick: handleClick,
        "data-test-id": "show-more-tags",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customer-data-board-card.recordTags.hasMore",
          options: {
            count: tagCount - 1
          }
        })
      })
    })
  });
};
export default TagsShowMore;